// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BriefParts-module__font-s-10___Lzp6W {
  font-size: 10px !important;
}

.BriefParts-module__font-s-12___ICKf2 {
  font-size: 12px !important;
}

.BriefParts-module__font-s-13___s5Yag {
  font-size: 13px !important;
}

.BriefParts-module__font-s-14___JlT8x {
  font-size: 14px !important;
}

.BriefParts-module__font-s-15___r5A1Y {
  font-size: 15px !important;
}

.BriefParts-module__font-s-16___NW_88 {
  font-size: 16px !important;
}

.BriefParts-module__font-s-18___Ub7Vq {
  font-size: 18px !important;
}

.BriefParts-module__font-s-20___eegeh {
  font-size: 20px !important;
}

.BriefParts-module__font-s-22___UD1d7 {
  font-size: 22px !important;
}

.BriefParts-module__font-s-28___qFgLS {
  font-size: 28px !important;
}

.BriefParts-module__font-w-400___Z_0r3 {
  font-weight: 400 !important;
}

.BriefParts-module__font-w-500___luciL {
  font-weight: 500 !important;
}

.BriefParts-module__font-w-600___oKylF {
  font-weight: 600 !important;
}

.BriefParts-module__font-w-700___nteE6 {
  font-weight: 700 !important;
}

.BriefParts-module__p-5___rBnom {
  padding: 5px !important;
}

.BriefParts-module__p-12___orLKc {
  padding: 12px !important;
}

.BriefParts-module__p-16___QOZfq {
  padding: 16px !important;
}

.BriefParts-module__p-30___BjVs0 {
  padding: 30px !important;
}

.BriefParts-module__p-b-0___OjC7y {
  padding-bottom: 0 !important;
}

.BriefParts-module__p-b-5___Fdfdn {
  padding-bottom: 5px !important;
}

.BriefParts-module__p-b-10___HNhYR {
  padding-bottom: 10px !important;
}

.BriefParts-module__p-b-12___hrC4S {
  padding-bottom: 12px !important;
}

.BriefParts-module__p-b-16___kpql3 {
  padding-bottom: 16px !important;
}

.BriefParts-module__p-b-18___HgYfs {
  padding-bottom: 18px !important;
}

.BriefParts-module__p-b-20___wcOqt {
  padding-bottom: 20px !important;
}

.BriefParts-module__p-b-25___TIfEz {
  padding-bottom: 25px !important;
}

.BriefParts-module__p-b-30___rgMY4 {
  padding-bottom: 30px !important;
}

.BriefParts-module__p-b-50___CUGCo {
  padding-bottom: 50px !important;
}

.BriefParts-module__p-t-0___yjWe6 {
  padding-top: 0 !important;
}

.BriefParts-module__p-t-12___cQW9C {
  padding-top: 12px !important;
}

.BriefParts-module__p-t-16___Fm0Qz {
  padding-top: 16px !important;
}

.BriefParts-module__p-t-18___NG4BR {
  padding-top: 18px !important;
}

.BriefParts-module__p-t-20___MwYRT {
  padding-top: 20px !important;
}

.BriefParts-module__p-t-30___E4f2c {
  padding-top: 30px !important;
}

.BriefParts-module__p-t-40___fXtBw {
  padding-top: 40px !important;
}

.BriefParts-module__p-t-50___hAdDd {
  padding-top: 50px !important;
}

.BriefParts-module__p-l-20___ZEtJR {
  padding-left: 20px !important;
}

.BriefParts-module__p-l-30___xQxkf {
  padding-left: 30px !important;
}

.BriefParts-module__p-l-40___NUAX1 {
  padding-left: 40px !important;
}

.BriefParts-module__p-r-16___vuXW9 {
  padding-right: 16px !important;
}

.BriefParts-module__p-r-20___kKOXY {
  padding-right: 20px !important;
}

.BriefParts-module__p-r-30___LUJk2 {
  padding-right: 30px !important;
}

.BriefParts-module__p-r-50___uDjqJ {
  padding-right: 50px !important;
}

.BriefParts-module__p-r-60___D17zL {
  padding-right: 60px !important;
}

.BriefParts-module__m-b-1___tqHto {
  margin-bottom: 1px !important;
}

.BriefParts-module__m-b-2___pWBaH {
  margin-bottom: 2px !important;
}

.BriefParts-module__m-b-6___Erqqe {
  margin-bottom: 6px !important;
}

.BriefParts-module__m-b-8___aT1Bs {
  margin-bottom: 8px !important;
}

.BriefParts-module__m-b-10___rq01K {
  margin-bottom: 10px !important;
}

.BriefParts-module__m-b-14___Mk5W5 {
  margin-bottom: 14px !important;
}

.BriefParts-module__m-b-16___wS4G0 {
  margin-bottom: 16px !important;
}

.BriefParts-module__m-b-20___hCbCv {
  margin-bottom: 20px !important;
}

.BriefParts-module__m-b-22___VOHRK {
  margin-bottom: 22px !important;
}

.BriefParts-module__m-b-24___gc7S_ {
  margin-bottom: 24px !important;
}

.BriefParts-module__m-b-30___ZUR6f {
  margin-bottom: 30px !important;
}

.BriefParts-module__m-b-32___NxhyZ {
  margin-bottom: 32px !important;
}

.BriefParts-module__m-b-40___WrpNn {
  margin-bottom: 40px !important;
}

.BriefParts-module__m-t-2___GV1Ah {
  margin-top: 2px !important;
}

.BriefParts-module__m-t-3___PNGDc {
  margin-top: 3px !important;
}

.BriefParts-module__m-t-4___Xb1zO {
  margin-top: 4px !important;
}

.BriefParts-module__m-t-5___JtGAh {
  margin-top: 5px !important;
}

.BriefParts-module__m-t-8___aSlwc {
  margin-top: 8px !important;
}

.BriefParts-module__m-t-10___HvMlz {
  margin-top: 10px !important;
}

.BriefParts-module__m-t-15___fw8Hs {
  margin-top: 15px !important;
}

.BriefParts-module__m-t-16___XzF9R {
  margin-top: 16px !important;
}

.BriefParts-module__m-t-20___SVOdL {
  margin-top: 20px !important;
}

.BriefParts-module__m-t-22___LNs6R {
  margin-top: 22px !important;
}

.BriefParts-module__m-t-30___BE0SB {
  margin-top: 30px !important;
}

.BriefParts-module__m-t-32___NNtBi {
  margin-top: 32px !important;
}

.BriefParts-module__m-l-auto___Mkz0x {
  margin-left: auto !important;
}

.BriefParts-module__m-l-4____7liH {
  margin-left: 4px !important;
}

.BriefParts-module__m-l-5___Lrvqr {
  margin-left: 5px !important;
}

.BriefParts-module__m-l-6___RylMw {
  margin-left: 6px !important;
}

.BriefParts-module__m-l-8___YpvVg {
  margin-left: 8px !important;
}

.BriefParts-module__m-l-10___iVhQu {
  margin-left: 10px !important;
}

.BriefParts-module__m-l-16___B_czU {
  margin-left: 16px !important;
}

.BriefParts-module__m-l-20___ny89X {
  margin-left: 20px !important;
}

.BriefParts-module__m-l-24___x84Ap {
  margin-left: 24px !important;
}

.BriefParts-module__m-l-30___vg7fJ {
  margin-left: 30px !important;
}

.BriefParts-module__m-l-35___UznIO {
  margin-left: 35px !important;
}

.BriefParts-module__m-l-40___wDLZc {
  margin-left: 40px !important;
}

.BriefParts-module__m-r-8___w0wYd {
  margin-right: 8px !important;
}

.BriefParts-module__m-r-10___n9WOn {
  margin-right: 10px !important;
}

.BriefParts-module__m-r-16___gzUiz {
  margin-right: 16px !important;
}

.BriefParts-module__m-r-20___LYMtN {
  margin-right: 20px !important;
}

.BriefParts-module__m-r-24___arp5I {
  margin-right: 24px !important;
}

.BriefParts-module__m-r-30___JA_4M {
  margin-right: 30px !important;
}

.BriefParts-module__m-r-40___bsUSo {
  margin-right: 40px !important;
}

.BriefParts-module__border-r-3___m_c1L {
  border-radius: 3px !important;
}

.BriefParts-module__border-r-4___cN6EL {
  border-radius: 4px !important;
}

.BriefParts-module__border-r-6___FP7Ws {
  border-radius: 6px !important;
}

.BriefParts-module__border-r-10___A1pp9 {
  border-radius: 10px !important;
}

.BriefParts-module__border-r-12___naP2Q {
  border-radius: 12px !important;
}

.BriefParts-module__border-r-16___JfGOX {
  border-radius: 16px !important;
}

.BriefParts-module__border-r-50___LCyTb {
  border-radius: 50% !important;
}

.BriefParts-module__primary-border___ePrGK {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefParts-module__primary-border-b___C2oOy {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefParts-module__primary-border-t___pMs8P {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefParts-module__primary-border-l___oa78I {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefParts-module__primary-border-r___O4L6u {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BriefParts-module__secondary-border___A84qX {
  border: 1px solid #637768;
}

.BriefParts-module__secondary-border-b___w0kTt {
  border-bottom: 1px solid #637768;
}

.BriefParts-module__secondary-border-t___lHd7M {
  border-top: 1px solid #637768;
}

.BriefParts-module__secondary-border-l___le_tM {
  border-left: 1px solid #637768;
}

.BriefParts-module__secondary-border-r___MHN4R {
  border-right: 1px solid #637768;
}

.BriefParts-module__gap-0___rDf1k {
  gap: 0 !important;
}

.BriefParts-module__gap-2___xOObB {
  gap: 2px !important;
}

.BriefParts-module__gap-4___MLvwL {
  gap: 4px !important;
}

.BriefParts-module__gap-5___F1QiQ {
  gap: 5px !important;
}

.BriefParts-module__gap-6___hiqsl {
  gap: 6px !important;
}

.BriefParts-module__gap-8___lz3WL {
  gap: 8px !important;
}

.BriefParts-module__gap-10___iGuz2 {
  gap: 10px !important;
}

.BriefParts-module__gap-12___i7zwN {
  gap: 12px !important;
}

.BriefParts-module__gap-14___cmWwV {
  gap: 14px !important;
}

.BriefParts-module__gap-16___iexTT {
  gap: 16px !important;
}

.BriefParts-module__gap-18___fiDNL {
  gap: 18px !important;
}

.BriefParts-module__gap-20___Lvczp {
  gap: 20px !important;
}

.BriefParts-module__gap-24___cI1yd {
  gap: 24px !important;
}

.BriefParts-module__gap-26___TPV1R {
  gap: 26px !important;
}

.BriefParts-module__gap-30___qxknb {
  gap: 30px !important;
}

.BriefParts-module__gap-32___KWF2P {
  gap: 32px !important;
}

.BriefParts-module__gap-40___ZoH_W {
  gap: 40px !important;
}

.BriefParts-module__gap-50___E3ann {
  gap: 50px !important;
}

.BriefParts-module__flex-1___GhrDi {
  flex: 1;
}

.BriefParts-module__flex-none___wMNyw {
  flex: none !important;
}

.BriefParts-module__flex-column___wrbq2 {
  display: flex;
  flex-direction: column !important;
}

.BriefParts-module__flex-row___OJ7Nq {
  display: flex;
  flex-direction: row !important;
}

.BriefParts-module__vertically-centered___qPh4J {
  display: flex;
  align-items: center !important;
}

.BriefParts-module__horizontally-centered___JWa3D {
  display: flex;
  justify-content: center !important;
}

.BriefParts-module__horizontally-end___YaETb {
  display: flex;
  justify-content: end !important;
}

.BriefParts-module__vertically-start___luzHL {
  display: flex;
  align-items: start !important;
}

.BriefParts-module__space-between___Z8NCR {
  display: flex;
  justify-content: space-between !important;
}

.BriefParts-module__flex-wrap___XrVjB {
  flex-wrap: wrap !important;
}

.BriefParts-module__height-100___bPFRb {
  height: 100%;
}

.BriefParts-module__width-50___g0xV5 {
  width: 50% !important;
}

.BriefParts-module__width-100___phHmf {
  width: 100%;
}

.BriefParts-module__cursor-pointer___e0Kck {
  cursor: pointer;
}

.BriefParts-module__cursor-not-allowed___OMtgK {
  cursor: not-allowed !important;
}

.BriefParts-module__absolute-centered___Rc3Y0 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BriefParts-module__absolute___Df7hC {
  position: absolute;
}

.BriefParts-module__relative___mrXe2 {
  position: relative;
}

.BriefParts-module__fixed___vRC6c {
  position: fixed;
}

.BriefParts-module__visible___tGYzr {
  opacity: 1;
}

.BriefParts-module__invisible___aPTLs {
  opacity: 0;
}

.BriefParts-module__col-90___Wmvqj {
  width: 90% !important;
}

.BriefParts-module__col-auto___bA6xo {
  width: auto !important;
}

.BriefParts-module__medical-tabs___v4zWG {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BriefParts-module__medical-table-new___RtBLF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BriefParts-module__medical-table-new___RtBLF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BriefParts-module__medical-table-new___RtBLF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BriefParts-module__medical-table-new___RtBLF::-webkit-scrollbar-track {
  display: none;
}
.BriefParts-module__medical-table-new___RtBLF.BriefParts-module__no-pagination___aZOvk {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BriefParts-module__medical-table-new___RtBLF.BriefParts-module__no-pagination___aZOvk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BriefParts-module__medical-table-new___RtBLF.BriefParts-module__no-pagination___aZOvk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BriefParts-module__medical-table-new___RtBLF.BriefParts-module__no-pagination___aZOvk::-webkit-scrollbar-track {
  display: none;
}

.BriefParts-module__medical-table-empty___udIWG {
  padding: 14px 40px !important;
}

.BriefParts-module__icon-btn___F07iH {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BriefParts-module__search-icon___ucUXH {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BriefParts-module__disable-select___s5LzK {
  user-select: none;
}

.BriefParts-module__break-word___HA7Aw {
  word-break: break-word;
}

.BriefParts-module__popup-clear-btn___LyKIN {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BriefParts-module__scroll-m-b-20___PUMst {
  scroll-margin-bottom: 20px;
}

.BriefParts-module__item___JCh37 {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 6px 16px;
  transition: background-color 0.15s;
}
.BriefParts-module__item___JCh37:hover {
  background: #fafafa;
}

.BriefParts-module__itemBody___lL82T {
  display: flex;
  min-width: 0;
  flex: 1 1 12rem;
  flex-direction: column;
  gap: 4px;
}

.BriefParts-module__itemActions___XlU1H {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
}

.BriefParts-module__field___WLJj7 {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  align-items: baseline;
  column-gap: 12px;
  font-size: 15px;
  line-height: 1.5;
  color: #18181b;
}

.BriefParts-module__fieldValue___ffxjX {
  min-width: 0;
}

@container (max-width: 447px) {
  .BriefParts-module__field___WLJj7 {
    grid-template-columns: 1fr;
    row-gap: 2px;
  }
}
.BriefParts-module__lineButton___UrCWA {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.BriefParts-module__lineButton___UrCWA:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.BriefParts-module__lineButton___UrCWA {
  outline: none;
}
.BriefParts-module__lineButton___UrCWA:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.BriefParts-module__lineButton___UrCWA:disabled, .BriefParts-module__lineButton___UrCWA[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}

.BriefParts-module__absent___t42AO {
  padding: 2px 0;
  font-size: 14px;
  line-height: 1.4286;
  white-space: nowrap;
  color: #a1a1aa;
}

.BriefParts-module__note___RCTfC {
  margin: 0;
  font-size: 14px;
  line-height: 1.4286;
  color: #71717a;
}

.BriefParts-module__toggle___xu9CX {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 4px;
  margin-top: 2px;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #1d4ed8;
  cursor: pointer;
}
.BriefParts-module__toggle___xu9CX:hover {
  text-decoration: underline;
}
.BriefParts-module__toggle___xu9CX {
  outline: none;
}
.BriefParts-module__toggle___xu9CX:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.BriefParts-module__toggleChevron___ww4Od {
  transition: transform 0.3s;
}

.BriefParts-module__toggleChevronOpen___weU7N {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/Visit/BriefParts.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;AA8pBF;AA5pBE;EACE,mBAAA;AA8pBJ;;AA1pBA;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,QAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,2CAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA6pBF;;AA1pBA;EACE,YAAA;AA6pBF;;AA1pBA;EACE;IACE,0BAAA;IACA,YAAA;EA6pBF;AACF;AA1pBA;EEFE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AF+pBF;AE7pBE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AF+pBJ;AAnrBA;EEXE,aAAA;AFisBF;AE/rBE;EACE,0BAAA;EACA,mBALuB;AFssB3B;AEjqBE;EAEE,cAAA;EACA,eAAA;AFkqBJ;;AA1rBA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AA6rBF;;AA1rBA;EACE,SAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AA6rBF;;AA1rBA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA6rBF;AA3rBE;EACE,0BAAA;AA6rBJ;AA7sBA;EE9BE,aAAA;AF8uBF;AE5uBE;EACE,0BAAA;EACA,mBALuB;AFmvB3B;;AA9rBA;EACE,0BAAA;AAisBF;;AA9rBA;EACE,yBAAA;AAisBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.item {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 6px 16px;\n  transition: background-color 0.15s;\n\n  &:hover {\n    background: #fafafa;\n  }\n}\n\n.itemBody {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 12rem;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.itemActions {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 6px;\n}\n\n.field {\n  display: grid;\n  grid-template-columns: 120px minmax(0, 1fr);\n  align-items: baseline;\n  column-gap: 12px;\n  font-size: 15px;\n  line-height: 1.5;\n  color: #18181b;\n}\n\n.fieldValue {\n  min-width: 0;\n}\n\n@container (max-width: 447px) {\n  .field {\n    grid-template-columns: 1fr;\n    row-gap: 2px;\n  }\n}\n\n.lineButton {\n  @include line-button;\n}\n\n.absent {\n  padding: 2px 0;\n  font-size: 14px;\n  line-height: 1.4286;\n  white-space: nowrap;\n  color: #a1a1aa;\n}\n\n.note {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4286;\n  color: #71717a;\n}\n\n.toggle {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  gap: 4px;\n  margin-top: 2px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: #1d4ed8;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  @include focus-ring;\n}\n\n.toggleChevron {\n  transition: transform 0.3s;\n}\n\n.toggleChevronOpen {\n  transform: rotate(180deg);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BriefParts-module__font-s-10___Lzp6W`,
	"fontS12": `BriefParts-module__font-s-12___ICKf2`,
	"fontS13": `BriefParts-module__font-s-13___s5Yag`,
	"fontS14": `BriefParts-module__font-s-14___JlT8x`,
	"fontS15": `BriefParts-module__font-s-15___r5A1Y`,
	"fontS16": `BriefParts-module__font-s-16___NW_88`,
	"fontS18": `BriefParts-module__font-s-18___Ub7Vq`,
	"fontS20": `BriefParts-module__font-s-20___eegeh`,
	"fontS22": `BriefParts-module__font-s-22___UD1d7`,
	"fontS28": `BriefParts-module__font-s-28___qFgLS`,
	"fontW400": `BriefParts-module__font-w-400___Z_0r3`,
	"fontW500": `BriefParts-module__font-w-500___luciL`,
	"fontW600": `BriefParts-module__font-w-600___oKylF`,
	"fontW700": `BriefParts-module__font-w-700___nteE6`,
	"p5": `BriefParts-module__p-5___rBnom`,
	"p12": `BriefParts-module__p-12___orLKc`,
	"p16": `BriefParts-module__p-16___QOZfq`,
	"p30": `BriefParts-module__p-30___BjVs0`,
	"pB0": `BriefParts-module__p-b-0___OjC7y`,
	"pB5": `BriefParts-module__p-b-5___Fdfdn`,
	"pB10": `BriefParts-module__p-b-10___HNhYR`,
	"pB12": `BriefParts-module__p-b-12___hrC4S`,
	"pB16": `BriefParts-module__p-b-16___kpql3`,
	"pB18": `BriefParts-module__p-b-18___HgYfs`,
	"pB20": `BriefParts-module__p-b-20___wcOqt`,
	"pB25": `BriefParts-module__p-b-25___TIfEz`,
	"pB30": `BriefParts-module__p-b-30___rgMY4`,
	"pB50": `BriefParts-module__p-b-50___CUGCo`,
	"pT0": `BriefParts-module__p-t-0___yjWe6`,
	"pT12": `BriefParts-module__p-t-12___cQW9C`,
	"pT16": `BriefParts-module__p-t-16___Fm0Qz`,
	"pT18": `BriefParts-module__p-t-18___NG4BR`,
	"pT20": `BriefParts-module__p-t-20___MwYRT`,
	"pT30": `BriefParts-module__p-t-30___E4f2c`,
	"pT40": `BriefParts-module__p-t-40___fXtBw`,
	"pT50": `BriefParts-module__p-t-50___hAdDd`,
	"pL20": `BriefParts-module__p-l-20___ZEtJR`,
	"pL30": `BriefParts-module__p-l-30___xQxkf`,
	"pL40": `BriefParts-module__p-l-40___NUAX1`,
	"pR16": `BriefParts-module__p-r-16___vuXW9`,
	"pR20": `BriefParts-module__p-r-20___kKOXY`,
	"pR30": `BriefParts-module__p-r-30___LUJk2`,
	"pR50": `BriefParts-module__p-r-50___uDjqJ`,
	"pR60": `BriefParts-module__p-r-60___D17zL`,
	"mB1": `BriefParts-module__m-b-1___tqHto`,
	"mB2": `BriefParts-module__m-b-2___pWBaH`,
	"mB6": `BriefParts-module__m-b-6___Erqqe`,
	"mB8": `BriefParts-module__m-b-8___aT1Bs`,
	"mB10": `BriefParts-module__m-b-10___rq01K`,
	"mB14": `BriefParts-module__m-b-14___Mk5W5`,
	"mB16": `BriefParts-module__m-b-16___wS4G0`,
	"mB20": `BriefParts-module__m-b-20___hCbCv`,
	"mB22": `BriefParts-module__m-b-22___VOHRK`,
	"mB24": `BriefParts-module__m-b-24___gc7S_`,
	"mB30": `BriefParts-module__m-b-30___ZUR6f`,
	"mB32": `BriefParts-module__m-b-32___NxhyZ`,
	"mB40": `BriefParts-module__m-b-40___WrpNn`,
	"mT2": `BriefParts-module__m-t-2___GV1Ah`,
	"mT3": `BriefParts-module__m-t-3___PNGDc`,
	"mT4": `BriefParts-module__m-t-4___Xb1zO`,
	"mT5": `BriefParts-module__m-t-5___JtGAh`,
	"mT8": `BriefParts-module__m-t-8___aSlwc`,
	"mT10": `BriefParts-module__m-t-10___HvMlz`,
	"mT15": `BriefParts-module__m-t-15___fw8Hs`,
	"mT16": `BriefParts-module__m-t-16___XzF9R`,
	"mT20": `BriefParts-module__m-t-20___SVOdL`,
	"mT22": `BriefParts-module__m-t-22___LNs6R`,
	"mT30": `BriefParts-module__m-t-30___BE0SB`,
	"mT32": `BriefParts-module__m-t-32___NNtBi`,
	"mLAuto": `BriefParts-module__m-l-auto___Mkz0x`,
	"mL4": `BriefParts-module__m-l-4____7liH`,
	"mL5": `BriefParts-module__m-l-5___Lrvqr`,
	"mL6": `BriefParts-module__m-l-6___RylMw`,
	"mL8": `BriefParts-module__m-l-8___YpvVg`,
	"mL10": `BriefParts-module__m-l-10___iVhQu`,
	"mL16": `BriefParts-module__m-l-16___B_czU`,
	"mL20": `BriefParts-module__m-l-20___ny89X`,
	"mL24": `BriefParts-module__m-l-24___x84Ap`,
	"mL30": `BriefParts-module__m-l-30___vg7fJ`,
	"mL35": `BriefParts-module__m-l-35___UznIO`,
	"mL40": `BriefParts-module__m-l-40___wDLZc`,
	"mR8": `BriefParts-module__m-r-8___w0wYd`,
	"mR10": `BriefParts-module__m-r-10___n9WOn`,
	"mR16": `BriefParts-module__m-r-16___gzUiz`,
	"mR20": `BriefParts-module__m-r-20___LYMtN`,
	"mR24": `BriefParts-module__m-r-24___arp5I`,
	"mR30": `BriefParts-module__m-r-30___JA_4M`,
	"mR40": `BriefParts-module__m-r-40___bsUSo`,
	"borderR3": `BriefParts-module__border-r-3___m_c1L`,
	"borderR4": `BriefParts-module__border-r-4___cN6EL`,
	"borderR6": `BriefParts-module__border-r-6___FP7Ws`,
	"borderR10": `BriefParts-module__border-r-10___A1pp9`,
	"borderR12": `BriefParts-module__border-r-12___naP2Q`,
	"borderR16": `BriefParts-module__border-r-16___JfGOX`,
	"borderR50": `BriefParts-module__border-r-50___LCyTb`,
	"primaryBorder": `BriefParts-module__primary-border___ePrGK`,
	"primaryBorderB": `BriefParts-module__primary-border-b___C2oOy`,
	"primaryBorderT": `BriefParts-module__primary-border-t___pMs8P`,
	"primaryBorderL": `BriefParts-module__primary-border-l___oa78I`,
	"primaryBorderR": `BriefParts-module__primary-border-r___O4L6u`,
	"secondaryBorder": `BriefParts-module__secondary-border___A84qX`,
	"secondaryBorderB": `BriefParts-module__secondary-border-b___w0kTt`,
	"secondaryBorderT": `BriefParts-module__secondary-border-t___lHd7M`,
	"secondaryBorderL": `BriefParts-module__secondary-border-l___le_tM`,
	"secondaryBorderR": `BriefParts-module__secondary-border-r___MHN4R`,
	"gap0": `BriefParts-module__gap-0___rDf1k`,
	"gap2": `BriefParts-module__gap-2___xOObB`,
	"gap4": `BriefParts-module__gap-4___MLvwL`,
	"gap5": `BriefParts-module__gap-5___F1QiQ`,
	"gap6": `BriefParts-module__gap-6___hiqsl`,
	"gap8": `BriefParts-module__gap-8___lz3WL`,
	"gap10": `BriefParts-module__gap-10___iGuz2`,
	"gap12": `BriefParts-module__gap-12___i7zwN`,
	"gap14": `BriefParts-module__gap-14___cmWwV`,
	"gap16": `BriefParts-module__gap-16___iexTT`,
	"gap18": `BriefParts-module__gap-18___fiDNL`,
	"gap20": `BriefParts-module__gap-20___Lvczp`,
	"gap24": `BriefParts-module__gap-24___cI1yd`,
	"gap26": `BriefParts-module__gap-26___TPV1R`,
	"gap30": `BriefParts-module__gap-30___qxknb`,
	"gap32": `BriefParts-module__gap-32___KWF2P`,
	"gap40": `BriefParts-module__gap-40___ZoH_W`,
	"gap50": `BriefParts-module__gap-50___E3ann`,
	"flex1": `BriefParts-module__flex-1___GhrDi`,
	"flexNone": `BriefParts-module__flex-none___wMNyw`,
	"flexColumn": `BriefParts-module__flex-column___wrbq2`,
	"flexRow": `BriefParts-module__flex-row___OJ7Nq`,
	"verticallyCentered": `BriefParts-module__vertically-centered___qPh4J`,
	"horizontallyCentered": `BriefParts-module__horizontally-centered___JWa3D`,
	"horizontallyEnd": `BriefParts-module__horizontally-end___YaETb`,
	"verticallyStart": `BriefParts-module__vertically-start___luzHL`,
	"spaceBetween": `BriefParts-module__space-between___Z8NCR`,
	"flexWrap": `BriefParts-module__flex-wrap___XrVjB`,
	"height100": `BriefParts-module__height-100___bPFRb`,
	"width50": `BriefParts-module__width-50___g0xV5`,
	"width100": `BriefParts-module__width-100___phHmf`,
	"cursorPointer": `BriefParts-module__cursor-pointer___e0Kck`,
	"cursorNotAllowed": `BriefParts-module__cursor-not-allowed___OMtgK`,
	"absoluteCentered": `BriefParts-module__absolute-centered___Rc3Y0`,
	"absolute": `BriefParts-module__absolute___Df7hC`,
	"relative": `BriefParts-module__relative___mrXe2`,
	"fixed": `BriefParts-module__fixed___vRC6c`,
	"visible": `BriefParts-module__visible___tGYzr`,
	"invisible": `BriefParts-module__invisible___aPTLs`,
	"col90": `BriefParts-module__col-90___Wmvqj`,
	"colAuto": `BriefParts-module__col-auto___bA6xo`,
	"medicalTabs": `BriefParts-module__medical-tabs___v4zWG`,
	"medicalTableNew": `BriefParts-module__medical-table-new___RtBLF`,
	"noPagination": `BriefParts-module__no-pagination___aZOvk`,
	"medicalTableEmpty": `BriefParts-module__medical-table-empty___udIWG`,
	"iconBtn": `BriefParts-module__icon-btn___F07iH`,
	"searchIcon": `BriefParts-module__search-icon___ucUXH`,
	"disableSelect": `BriefParts-module__disable-select___s5LzK`,
	"breakWord": `BriefParts-module__break-word___HA7Aw`,
	"popupClearBtn": `BriefParts-module__popup-clear-btn___LyKIN`,
	"scrollMB20": `BriefParts-module__scroll-m-b-20___PUMst`,
	"item": `BriefParts-module__item___JCh37`,
	"itemBody": `BriefParts-module__itemBody___lL82T`,
	"itemActions": `BriefParts-module__itemActions___XlU1H`,
	"field": `BriefParts-module__field___WLJj7`,
	"fieldValue": `BriefParts-module__fieldValue___ffxjX`,
	"lineButton": `BriefParts-module__lineButton___UrCWA`,
	"absent": `BriefParts-module__absent___t42AO`,
	"note": `BriefParts-module__note___RCTfC`,
	"toggle": `BriefParts-module__toggle___xu9CX`,
	"toggleChevron": `BriefParts-module__toggleChevron___ww4Od`,
	"toggleChevronOpen": `BriefParts-module__toggleChevronOpen___weU7N`
};
module.exports = ___CSS_LOADER_EXPORT___;
